<template>
  <div class="spinner-container" :class="containerClass">
    <div class="d-flex justify-content-center align-items-center">
      <div class="spinner-border" :class="spinnerClass" role="status">
        <span class="visually-hidden">{{ text }}</span>
      </div>
      <span v-if="showText" class="ms-2">{{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    // Color del spinner (primary, secondary, success, danger, warning, info, light, dark)
    color: {
      type: String,
      default: "primary",
    },
    // Texto a mostrar junto al spinner
    text: {
      type: String,
      default: "Loading...",
    },
    // Si mostrar o no el texto
    showText: {
      type: Boolean,
      default: true,
    },
    // Clases CSS adicionales para el contenedor
    containerClass: {
      type: String,
      default: "",
    },
    // Tamaño del spinner (sm, lg)
    size: {
      type: String,
      default: "",
    },
  },
  computed: {
    spinnerClass() {
      const classes = [`text-${this.color}`];
      if (this.size) {
        classes.push(`spinner-border-${this.size}`);
      }
      return classes.join(" ");
    },
  },
};
</script>

<style scoped>
.spinner-container {
  padding: 1rem;
}

.spinner-container.text-center {
  text-align: center;
}

.spinner-container.bg-white {
  background-color: white;
}

.spinner-container.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.spinner-container.w-100 {
  width: 100%;
}
</style>
